<template>
	<v-dialog :model-value="dialog.open" width="600" persistent>
		<v-card color="white">
			<v-card-title class="text-h1 font-weight-bold">
				Select split master station
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" @click="close" variant="plain"></v-btn>
			</v-card-title>
			<v-card-text class="text-body-2">
				<v-form ref="form" v-model="valid">
					<v-combobox
						v-model="splitMasterStation"
						variant="outlined" density="compact"
						placeholder="Select a station"
						:menu-props="{contentClass: 'mr-1'}"
						:items="splitMasterStations"
						item-title="StationName" item-value="StationID"
						return-object :loading="loadingStations"
						:error-messages="error"
						:rules="[v => !!v || 'This field is required']"
						required>
					</v-combobox>
					<!--					add loader-->
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="primary" @click="close">Close</v-btn>
				<v-btn color="primary" variant="flat" @click="selectStation(splitMasterStation)"
					class="ml-2"
					:disabled="!valid || loading" :loading="loading">
					Confirm
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>

/* Libraries */
import * as _ from "lodash";

/* Enums */
import SyndicationTypes from "@/enums/SyndicationTypes";

export default {
	name: "SelectSplitMasterStationDialog",

	props: ["dialog", "options"],

	emits: ["close"],

	data() {
		return {
			station: this.options.station,
			splitMasterStation: null,
			splitMasterStations: [],
			error: null,
			valid: true,
			loading: false,
			loadingStations: true
		}
	},

	methods: {
		loadSplitMasterStations() {
			this.$store.dispatch("getStationsBySyndicationType", SyndicationTypes.SplitMaster)
			    .then(stations => {
					this.splitMasterStations = stations;
					this.splitMasterStation = stations.find(s => s.StationID ===
				                                                 this.station.SplitMasterStationID);
				})
			    .catch(() =>
					this.$store.commit(
						"SHOW_NOTIFICATION_WITH_TYPE",
						{message: "An error occurred when trying to load the split master stations."}
					)
				).finally(() => this.loadingStations = false);
		},

		selectStation(selectedStation) {
			if (!_.isObject(selectedStation)) {	// station typed by the user
				return;
			}

			if (this.$refs.form.validate()) {
				if (selectedStation.StationID === this.station.SplitMasterStationID) {
					this.options.confirmAction();
					this.close();
				}
				else {
					this.loading = true;

					const payload = {
						SplitMasterStationID: selectedStation.StationID,
					}

					this.$store.dispatch(
						"updateStation",
						{stationID: this.station.StationID, payload}
					).then(() => {
							this.options.confirmAction();
							this.close();
						})
					    .finally(() => this.loading = false);
				}
			}
		},

		close() {
			this.$emit("close");
		}
	},

	mounted() {
		this.loadSplitMasterStations();
	}
};
</script>

<style lang="scss" scoped>
</style>
